import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-8" }
const _hoisted_2 = { class: "flex justify-between gap-4" }
const _hoisted_3 = ["disabled"]

import { useTasksStore } from '@/stores/v2';
import { storeToRefs } from 'pinia';
import { useFishTransfer } from "@/composables/tasks/animal-transfer/useAnimalTransfer";
import { computed } from 'vue';

import TaskHeader from '@/components/v2/Tasks/Task/TaskHeader.vue';
import OperationCard from '@/components/v2/Tasks/AnimalTransfer/Cards/OperationCard/OperationCard.vue';
import StatusCard from '@/components/v2/Tasks/AnimalTransfer/Cards/StatusCard/StatusCard.vue';
import TransferList from '@/components/v2/Tasks/AnimalTransfer/Lists/TransferList.vue';
import TransferInput from '@/components/v2/Tasks/AnimalTransfer/Forms/TransferInput.vue';
import FooterActions from '@/components/v2/Tasks/Vaccination/Buttons/ActionButtons/FooterActions.vue';
import FishTransferLogModal from '@/components/v2/Tasks/AnimalTransfer/Modals/TransferLogModal.vue';
import InstructionsModal from '@/components/v2/Tasks/AnimalTransfer/Modals/InstructionsModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { activeTask } = storeToRefs(useTasksStore())

const {
    newTags,
    transferInfo,
    transferBalance,
    actualTransfers,
    globalTransferAmount,
    fishTransferLogModal,
    instructionsModal,
    performOperation,
    handleCompleteTask,
    toggleInstructionsModal,
    toggleFishTransferLogModal,
} = useFishTransfer();

const isCompleteDisabled = computed(() => transferBalance.value < 1);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(activeTask))
      ? (_openBlock(), _createBlock(TaskHeader, {
          key: 0,
          title: _unref(activeTask).title,
          study: _unref(activeTask).studyTitle
        }, null, 8, ["title", "study"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(OperationCard, {
          class: "w-full",
          transferInfo: _unref(transferInfo),
          actualTransfers: _unref(actualTransfers),
          "new-tags": _unref(newTags)
        }, null, 8, ["transferInfo", "actualTransfers", "new-tags"]),
        _createVNode(StatusCard, {
          class: "w-full",
          transferInfo: _unref(transferInfo),
          transferBalance: _unref(transferBalance)
        }, null, 8, ["transferInfo", "transferBalance"])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "my-4 h-[1px] border-b border-gray-200 block" }, null, -1)),
      _createVNode(TransferList, {
        transfers: _unref(actualTransfers),
        transferInfo: _unref(transferInfo)
      }, null, 8, ["transfers", "transferInfo"]),
      _createVNode(TransferInput, {
        modelValue: _unref(globalTransferAmount),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(globalTransferAmount) ? (globalTransferAmount).value = $event : null)),
        transferInfo: _unref(transferInfo),
        performOperation: _unref(performOperation)
      }, null, 8, ["modelValue", "transferInfo", "performOperation"])
    ]),
    _createVNode(FooterActions, null, {
      start: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(toggleInstructionsModal) && _unref(toggleInstructionsModal)(...args))),
          class: "w-full"
        }, " Instructions ")
      ]),
      end: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(handleCompleteTask) && _unref(handleCompleteTask)(...args))),
          class: "w-full disabled:opacity-50 disabled:cursor-not-allowed",
          disabled: isCompleteDisabled.value
        }, " Complete task ", 8, _hoisted_3)
      ]),
      _: 1
    }),
    _createVNode(InstructionsModal, {
      showModal: _unref(instructionsModal),
      onClose: _unref(toggleInstructionsModal)
    }, null, 8, ["showModal", "onClose"]),
    _createVNode(FishTransferLogModal, {
      showModal: _unref(fishTransferLogModal),
      toggleFishTransferLogModal: _unref(toggleFishTransferLogModal),
      amount: _unref(transferBalance)
    }, null, 8, ["showModal", "toggleFishTransferLogModal", "amount"])
  ]))
}
}

})